/**
 * Checks if the passed string contains any items in an array
 *
 * @param {String} str - The string we will be searching
 * @param {Array} [items] - A list of the items we will be checking for presence in the str
 *
 * @returns {Boolean}
 */
export function doesStringContainAny(str, items = []) {
  return items.some(i => str.includes(i));
}
/**
 * camelCase a string
 *
 * @param {String} str
 *
 * @return {String} value - formatted value
 */

export function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}